// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	PurchaseMapButton: 'purchase-map-button',
	ExpandImageButton: 'expand-image-button',
	FullParcelIcon: 'full-parcel-icon',
	SelectTypeRadioGroup: 'select-type-radio-group',
	SelectTypeRadioGroup1: 'select-type-radio-group-1',
	TeranetMapPartLots: 'teranet-map-part-lots',
	TeranetMapFullLots: 'teranet-map-full-lots',
	TeranetMapOtherLots: 'teranet-map-other-lots',
	TeranetMapAllLots: 'teranet-map-all-lots',
	//	MyHookName: 'myHookIdentifier',
} as const;
/*
NOTE: The above hooks have been auto generated, all naming is a best guess approach.
Please review them, edit where necessary and delete this comment to indicate that the names are correct.
*/
